module.exports = __webpack_public_path__ + "img/personalizedService.dfdc6f9c.svg";